import type { TRADING_REQUEST_TYPES } from "./advanced-trading-request"
import { SchemaDeSer, SchemaDeSerBuilder } from "./deser"

// This may expand in the future to support other enablement types but is currently
// a subset of TRADING_REQUEST_TYPES
export type EnablementTypes = TRADING_REQUEST_TYPES.CRYPTOCURRENCY_TRADING

export class Enablement {
  enablementType: EnablementTypes | null = null
}

export const ENABLEMENT_DESER: SchemaDeSer<Enablement> = new SchemaDeSerBuilder(
  Enablement
)
  .ofString("enablementType")
  .toDeSer()
